module.exports = __webpack_public_path__ + "static/media/296143.677e653f.jpg";